/**
 * Add Z to the date string if it doesn't end with Z.
 *
 * @example
 * addZ("2021-01-01T00:00:00") -> "2021-01-01T00:00:00Z"
 * addZ("2021-01-01T00:00:00Z") -> "2021-01-01T00:00:00Z"
 */
export const addZ = (dateString: string): string =>
  dateString?.endsWith("Z") ? dateString : `${dateString}Z`;
